export default __webpack_public_path__ + "static/media/slot20.d4814164.png";